const data=[{
    name:"Suraj Singh",
    age:17,
    forte: [ {category:"cooking", experience_years :2 ,salary_per_month:"2000" },{category:"cleaning", experience_years :1 ,salary_per_month:"1000" }],
    description:" a passionate cook, with passion for making food and helping in other stuffs",
    languages:["Hind","Kannada"],
    phone_no:"735399998"
    },
    {
    name:"Varshitha Gupta",
    age:18,
    forte: [ {category:"cooking", experience_years :3 ,salary_per_month:"5000" }],
    description:" an honest cook,who loves cooking ",
    languages:["Hind"],
    phone_no:"7892658997"
    },
    {
    name:"Pranya Shetty",
    age:18,
    forte: [ {category:"cooking", experience_years :7 ,salary_per_month:"10000" },{category:"cleaning", experience_years :3 ,salary_per_month:"5000" }],
    description:" Loves to cook and clean. A very friendly and kind hearted person",
    languages:["Hind","Bhojpuri"],
    phone_no:"9880757678"
    },
    {
    name:"Vignesh",
    age:29,
    forte: [ {category:"baby caretaker", experience_years :5 ,salary_per_month:"18000" },{category:"cleaning", experience_years :7 ,salary_per_month:"2000" }],
    description:"An honest person with utmost love for babies. Can also do other works like cleaning",
    languages:["Hind","Urdu","Kannada"],
    phone_no:"6362585951"
    },
    {
    name:"Shalini Singh",
    age:45,
    forte: [ {category:"cooking", experience_years :5 ,salary_per_month:"7000" },{category:"cleaning", experience_years :1 ,salary_per_month:"2500" }],
    description:" a passionate cook, with passion for making food and hates seeing untidy floors ",
    languages:["Hind"],
    phone_no:"7751998496"
    },
    {
    name:"Revant Nayak",
    age:19,
    forte: [ {category:"cleaning", experience_years :2 ,salary_per_month:"3000" }],
    description:"An honest person doing studies along with helping other people clean their houses",
    languages:["Hind","Urdu"],
    phone_no:"8310813217"
    },
    {
    name:"Vishakh Aggarwal",
    age:20,
    forte: [ {category:"washing clothes", experience_years :2 ,salary_per_month:"2000" },{category:"cleaning", experience_years :1 ,salary_per_month:"1000" }],
    description:"Expert in cleaning of utensils, floors and washing clothes ",
    languages:["Punjabi","Hindi"],
    phone_no:"8653450123"
    },
    {
    name:"Rithin Chopda",
    age:20,
    forte: [ {category:"cleaning", experience_years :1 ,salary_per_month:"1000" }],
    description:"Hates seing anything untidy",
    languages:["Hind","Urdu","Kannada"],
    phone_no:"9898989898"
    },
    {
    name:"Sarvesh Sharma",
    age:20,
    forte: [ {category:"baby caretaker", experience_years :2 ,salary_per_month:"19000" },{category:"cleaning", experience_years :2 ,salary_per_month:"2000" }],
    description:"Loves to take care of children, and play with them",
    languages:["Hind","Urdu","Kannada"],
    phone_no:"9957630103"
    },
    {
    name:"Samyak Maheshwari",
    age:31,
    forte: [ {category:"cleaning", experience_years :3 ,salary_per_month:"3000" }],
    description:" Cleaning is my passion. I can clean anything in very less time",
    languages:["Hind","Urdu"],
    phone_no:"9964785810"
    },
    {
    name:"Salman Hassan",
    age:47,
    forte: [ {category:"cooking", experience_years :2 ,salary_per_month:"2000" },{category:"cleaning", experience_years :1 ,salary_per_month:"1000" },{category:"baby carertaker", experience_years :10 ,salary_per_month:"22000" }],
    description:" All in One qualities. Can do almost every household work",
    languages:["Urdu","Arabic"],
    phone_no:"9148728520"
    },
    {
    name:"Pranshu Sinha",
    age:22,
    forte: [ {category:"cooking", experience_years :1 ,salary_per_month:"2000" }],
    description:" a passionate cook, with passion for making food and helping in other stuffs",
    languages:["Hind"],
    phone_no:"8669976062"
    },
    {
    name:"Vellmati M",
    age:25,
    forte: [ {category:"cooking", experience_years :3 ,salary_per_month:"5000" },{category:"cleaning", experience_years :1 ,salary_per_month:"4000" }],
    description:" I had been a chef in a restaurant. I know exactly how to make food tasty. I am also an expert in cleaning",
    languages:["Hind","Kannada"],
    phone_no:"9698989786"
    },
    {
    name:"Andrew Garfield",
    age:25,
    forte: [ {category:"baby caretaker", experience_years :5 ,salary_per_month:"19000" }],
    description:"I love taking care of babies.",
    languages:["Hind","Urdu","English"],
    phone_no:"9298789898"
    },
    {
    name:"Aditi Umesh Nayak",
    age:49,
    forte: [ {category:"cooking", experience_years :2 ,salary_per_month:"2000" },{category:"cleaning", experience_years :1 ,salary_per_month:"1000" }],
    description:" I can cook almost every dish that exits in India. I am also an expert in cleaning ",
    languages:["Hind","Bhojpuri"],
    phone_no:"9763289090"
    },
    {
    name:"Taraka Tapasvi",
    age:23,
    forte: [ {category:"cooking", experience_years :1 ,salary_per_month:"1000" },{category:"cleaning", experience_years :1 ,salary_per_month:"3000" }],
    description:" I can cook all traditional food . Also I make sure that everything around is clean and hygienic",
    languages:["Kannada","English","Bengali"],
    phone_no:"9987986898"
    },
    {
    name:"Taarak Mehta",
    age:24,
    forte: [ {category:"cooking", experience_years :2 ,salary_per_month:"2000" },{category:"cleaning", experience_years :1 ,salary_per_month:"1000" }],
    description:"I can cook Marvadi, Pathani and South Indian dishes. Also I understand the importance of keeping the house clean",
    languages:["Hind","Urdu"],
    phone_no:"9792999398"
    },  
    {
    name:"Atmaram Bhide",
    age:55,
    forte: [ {category:"cooking", experience_years :5 ,salary_per_month:"5000" }],
    description:" I can cook all the traditional foods and sweets.",
    languages:["Hind","Sanskrit","Bengali"],
    phone_no:"9712345890"
    }]

    export default data;